import React from "react";
import { useParams } from "react-router-dom";
import { TransactionDetail } from "@app.automotus.io/components/TransactionDetail";

export const Transaction: React.FC = () => {
  const { transactionId = "" } = useParams<{ transactionId: string }>();

  return <TransactionDetail transactionId={transactionId} />;
};
